import React, { useState, useEffect } from 'react'
import { DownloadButton, Font, Wrapper, QrCode } from 'components'
import { ReactComponent as Logo } from 'assets/images/logotype.svg'
import image from 'assets/images/phone_1.png'
import imageWebp from 'assets/images/phone_1.webp'
import styles from './styles.module.scss'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const items = [
  'icecream',
  'matcha',
  'pizza',
  'latte',
  'burger',
  'espresso',
  'pasta',
]

const HeaderSection = () => {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    const intervalId = setInterval(
      () =>
        setIndex(i => {
          if (i === items.length - 1) return 0
          return i + 1
        }),
      500,
    )

    return () => clearInterval(intervalId)
  }, [])

  return (
    <div className={styles.container}>
      <Wrapper>
        <header className={styles.section}>
          <div className={styles.leftColumn}>
            <Logo className={styles.logo} />
            <div className={styles.row}>
              <div className={styles.qrContainer}>
                <QrCode className={styles.qrCode} />
                <DownloadButton className={styles.downloadButton} />
              </div>
              <div>
                <Font className={styles.title} type="heading" color="white">
                  share your
                </Font>
                <Font
                  className={styles.dynamicTitle}
                  type="heading"
                  color="white"
                >
                  {items[index]}
                </Font>
              </div>
            </div>
          </div>
          <div className={styles.rightColumn}>
            <picture>
              <source srcSet={imageWebp} type="image/webp" />
              <source srcSet={image} type="image/jpeg" />
              <img className={styles.image} src={image} alt="Phone" />
            </picture>
          </div>
        </header>
      </Wrapper>
    </div>
  )
}

export default HeaderSection
